<template>
    <div id="echart-ppi" :style="{ height: '800px',width:'100%'}" ></div>   
</template>

<script>

var myChart;
var option;
export default({
    props:{
        nodes:Array,
        edges:Array,
        legendAll:Boolean
    },
    data(){
        return{
            categories:[
                {name: '1'},
                {name: '2'},
                {name: '3'},
                {name: '4'},
                {name: '5'},
                {name: '6'},
                {name: '7'},
                {name: '8'},
                {name: '9'},
                {name: '10'},
                {name: '11'},
                {name: '12'},
                {name: '13'},
                {name: '14'},
                {name: '15'},
                {name: '16'},
                {name: '17'},
                {name: '18'},
                {name: '19'},
                {name: '20'},
                {name: '21'},
                {name: '22'},
                {name: 'X'},
                {name: 'Y'},
            ],
            selected:{ 
                '7': false,
                '8': false,
                '9': false,
                '10': false,
                '11': false,
                '12': false,
                '13': false,
                '14': false,
                '15': false,
                '16': false,
                '17': false,
                '18': false,
                '19': false,
                '20': false,
                '21': false,
                '22':false,
                'X': false,
                'Y': false,
            },
        }
    },
    watch:{
        nodes(){
            this.initChart()
        },
        legendAll(){
            this.setLegend()
        }
    },
        
    methods: {
        initChart() {
            // 如果已存在视图实例，则先销毁后创建
            if (myChart != null && myChart != "" && myChart != undefined) {
                myChart.dispose();
            }
            // 基于准备好的dom，初始化echarts实例
            myChart = this.echarts.init(document.getElementById("echart-ppi"));
            option = {
                tooltip: {
                    formatter: function (param) {
                        var value = param.data;
                        if(value['name'])
                        return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                                    + value['name']
                                    + '</div>'
                                    + 'Gene id: ' + value['gene_id'] + '<br>' 
                                    + 'Location: ' + value['location'] + '<br>' 
                                    + 'Score in DisGeNET: ' + value['score'] + '<br>' 
                                    + 'Gene type: ' + value['type'] + '<br>' 
                        else return value['source'] + '--' +value['target']+'<br>'
                                    + 'Score: ' + value['score'] + '<br>' 
                    }
                },
                title: {
                    text: 'Chromosome'
                },
                toolbox: {
                    left: 150,
                    feature: {
                        restore: {
                            title:"Restore"
                        },
                        saveAsImage: {
                            title:"Download as image"
                        }
                    }
                },
                legend: [
                    {
                        orient: 'vertical',
                        left: 10,
                        top:40,
                        selected: this.selected,
                        data: this.categories.map(function (a) {
                            return a.name;
                        })
                    }
                ],
                animationDuration: 500,
                animationEasingUpdate: 'quinticInOut',
                series: [
                {
                    type: 'graph',
                    layout: 'circular',
                    draggable: true,
                    categories:this.categories,
                    data:  this.nodes.map(function (node) {
                        return {
                            id: node.gene_name,
                            name: node.gene_name,
                            category: node.chromosome+"",
                            gene_id:node.gene_id,
                            location:node.map_location,
                            score:node.score_dgn,
                            type:node.gene_type

                        };
                    }),
                    links: this.edges.map(function (edge) {
                        return {
                            source: edge.protein1,
                            target: edge.protein2,
                            score:edge.score,
                            lineStyle: {
                                width:edge.score
                            },

                        };
                    }),
                    roam: true,
                    label: {
                        
                            position: 'right'
                    },
                    emphasis: {
                        focus: 'adjacency',
                        lineStyle: {
                            width: 10
                        }
                    }
                }

                ]
            };
            myChart.setOption(option);
            //随着屏幕大小调节图表
            window.addEventListener("resize", () => {
                myChart.resize();
            });
        },
        setLegend(){
            if(this.legendAll){
                this.selected={ 
                    '1': true,
                    '2': true,
                    '3': true,
                    '4': true,
                    '5': true,
                    '6': true,
                    '7': true,
                    '8': true,
                    '9': true,
                    '10': true,
                    '11': true,
                    '12': true,
                    '13': true,
                    '14': true,
                    '15': true,
                    '16': true,
                    '17': true,
                    '18': true,
                    '19': true,
                    '20': true,
                    '21': true,
                    'X': true,
                    'Y': true,
                        
                }
            }else this.selected={ 
                '7': false,
                '8': false,
                '9': false,
                '10': false,
                '11': false,
                '12': false,
                '13': false,
                '14': false,
                '15': false,
                '16': false,
                '17': false,
                '18': false,
                '19': false,
                '20': false,
                '21': false,
                'X': false,
                'Y': false,
            },

            this.initChart()
        }
    }
})
</script>
